<p>Status: <b>{{process.simpleStatusStr.toUpperCase()}}</b></p>
